import { useTranslation } from 'react-i18next';

const tones = {
  published: 'bg-state-ok/10 text-state-ok',
  active: 'bg-state-ok/10 text-state-ok',
  answered: 'bg-state-ok/10 text-state-ok',
  draft: 'bg-beam-light text-beam-graphite',
  new: 'bg-beam-blue/10 text-beam-blue',
  'in-review': 'bg-state-warn/10 text-state-warn',
  hidden: 'bg-state-critical/10 text-state-critical',
  suspended: 'bg-state-critical/10 text-state-critical',
  archived: 'bg-beam-light text-beam-graphite',
};

const labelKeys = {
  published: 'admin.published',
  draft: 'common.draft',
  hidden: 'admin.hidden',
  active: 'admin.active',
  suspended: 'admin.suspended',
  archived: 'admin.archived',
  answered: 'admin.answered',
  'in-review': 'admin.inReview',
  new: 'admin.statusNew',
};

/** Single source of truth for what a state looks like across the admin. */
export const StatusBadge = ({ status, className = '' }) => {
  const { t } = useTranslation();
  const key = String(status || '').toLowerCase();

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md px-2 py-1 text-xs font-extrabold ${
        tones[key] || 'bg-beam-light text-beam-graphite'
      } ${className}`}
    >
      {labelKeys[key] ? t(labelKeys[key]) : status || '-'}
    </span>
  );
};
